import { Component, EventEmitter, Output } from '@angular/core';
import { RiberaDefaultBtn } from "@ribera-web/ribera-default-btn";

@Component({
  selector: 'lib-tooltip-qr',
  imports: [RiberaDefaultBtn],
  templateUrl: './tooltip-qr.html',
  styleUrl: './tooltip-qr.scss',
})
export class TooltipQR {
  @Output() close = new EventEmitter<void>();
  
  onCopyCode() {
    const code = 'PRJVC74010554';

    navigator.clipboard.writeText(code)
      .then(() => console.log('Código copiado al portapapeles'))
      .catch(err => console.error('Error al copiar el código', err))
      .finally(() => this.close.emit());
  }
}
